import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import ReportRequestStatus from "./reportRequestStatus";
import InternalReportType from "./internalReportType";
import { czechTodayDate, endOfCzechDay } from "utils/dateUtils";
import { startOfEDAZDistribution } from "config";
import { startOfCzechDay } from "../utils/dateUtils";
import { addDays, endOfDay, isValid, subDays } from "date-fns";

export default class InternalBusinessReportRequest {
  @observable
  type!: ReportRequestStatus;

  @observable
  @Type(() => Date)
  fromDate?: Date;

  @observable
  @Type(() => Date)
  toDate?: Date;

  @observable
  report!: InternalReportType;

  @observable
  name!: string;
}

export const InternalReportRequestBusinessValidationRules: EntityValidationRules<InternalBusinessReportRequest> = {
  fromDate: {
    isBefore: {
      condition: (entity: InternalBusinessReportRequest) =>
        isValid(entity.toDate) && entity.toDate ? startOfCzechDay(addDays(entity.toDate, 1)) : entity.toDate,
    },
    isAfter: {
      after: endOfDay(subDays(startOfEDAZDistribution, 1)),
    },
  },
  toDate: {
    isAfter: {
      condition: (entity: InternalBusinessReportRequest) =>
        entity.fromDate ? endOfCzechDay(addDays(entity.fromDate, -1)) : entity.fromDate,
    },
    isBefore: {
      before: startOfCzechDay(addDays(czechTodayDate(), 1)),
    },
  },
};
